import Client from './client.container'

export default Client
